export const RequestStatus = {
  COMPLETE: 'COMPLETE',
  VERIFICATION: 'VERIFICATION',
  PENDING: 'PENDING',
  REJECTION: 'REJECTION',
  VERIFICATION_PENDING: 'VERIFICATION_PENDING',
  VERIFICATION_FAILED: 'VERIFICATION_FAILED',
};

export const BulkOperationStatus = {
  COMPLETED: 'COMPLETED',
  PENDING: 'PENDING',
  ONGOING: 'ONGOING',
  FAILED: 'FAILED',
};

export const OtpHeaderValue = {
  CONSENTIN: 'CONSENTIN',
  CONSENT_TEST: 'CONSENT_TEST',
};
